import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import PinInput from './PinInput'
import Settings from './component'
import Debug from './Debug'
import ErrorLog from './ErrorLog'

import { registerDevice, onHostChange, getHostname } from '../../../redux/device'

class SettingsContainer extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      gameId: props.gameId,
      selectedTeam: props.teamId,
      isMaster: props.isMaster,
      sideBarFontSize: props.sideBarFontSize,
      newHostname: props.hostname,
      hostType: props.hostType,
      hostEnv: props.hostEnv,
      hostRole: props.hostRole,
      pinEntered: false,
      showDebug: false,
      showErrorLog: false
    }
  }

  componentDidMount = () => {
    this.setState({
      newHostname: this.props.hostname,
      hostEnv: this.props.hostEnv,
      hostRole: this.props.hostRole,
      hostType: this.props.hostType,
      gameId: this.props.gameId
    })
  }

  handleTeamSelect = team => {
    this.setState({
      selectedTeam: team
    })
  }

  handleSideBarFontSizeSelect = fontSize => {
    this.setState({
      sideBarFontSize: fontSize
    })
  }

  handleConfirm = async () => {
    await this.props.onHostChange({
      hostname: this.state.newHostname,
      hostEnv: this.state.hostEnv,
      hostRole: this.state.hostRole,
      hostType: this.state.hostType
    })
    await this.props.registerDevice(this.props.deviceId, this.state.selectedTeam, this.state.isMaster, this.state.sideBarFontSize, this.state.gameId)
  }

  handleMasterSelect = () => {
    this.setState({
      isMaster: !this.state.isMaster
    })
  }

  handlePinComplete = () => {
    this.setState({ pinEntered: true })
  }

  handleShowDebug = () => {
    this.setState({ showDebug: true })
  }

  handleCloseDebug = () => {
    this.setState({ showDebug: false })
  }

  handleShowErrorLog = () => {
    this.setState({ showErrorLog: true })
  }

  handleCloseErrorLog = () => {
    this.setState({ showErrorLog: false })
  }

  handleGameIdChange = gameId => {
    this.setState({ gameId })
  }

  handleHostNameChange = host => {
    this.setState({ newHostname: host })
  }

  handleHostTypeChange = hostType => {
    if (hostType === 'manual') {
      this.setState({ hostType })
    } else {
      this.setState({ hostType, newHostname: getHostname({ hostType, hostEnv: this.state.hostEnv, hostRole: this.state.hostRole }) })
    }
  }

  handleHostEnvChange = hostEnv => {
    this.setState({ hostEnv, newHostname: getHostname({ hostType: this.state.hostType, hostEnv, hostRole: this.state.hostRole }) })
  }

  handleHostRoleChange = hostRole => {
    this.setState({ hostRole, newHostname: getHostname({ hostType: this.state.hostType, hostEnv: this.state.hostEnv, hostRole }) })
  }

  handleCloseSettings = () => this.props.closeSettings()

  render () {
    if (!this.state.pinEntered) {
      return <PinInput onComplete={this.handlePinComplete} onCancel={this.handleCloseSettings} />
    }
    if (this.state.showDebug) {
      return <Debug onCloseDebug={this.handleCloseDebug} />
    }
    if (this.state.showErrorLog) {
      return <ErrorLog onCloseErrorLog={this.handleCloseErrorLog} />
    }
    return (
      <Settings
        error={this.props.registerError}
        onConfirm={this.handleConfirm}
        onCancel={this.handleCloseSettings}
        onTeamSelect={this.handleTeamSelect}
        selectedTeam={this.state.selectedTeam}
        isMaster={this.state.isMaster}
        onMasterSelect={this.handleMasterSelect}
        registering={this.props.registering}
        sideBarFontSize={this.state.sideBarFontSize}
        onSideBarFontSizeSelect={this.handleSideBarFontSizeSelect}
        onShowDebug={this.handleShowDebug}
        onShowErrorLog={this.handleShowErrorLog}
        newHostname={this.state.newHostname}
        onHostNameChange={this.handleHostNameChange}
        hostType={this.state.hostType}
        onHostTypeChange={this.handleHostTypeChange}
        hostEnv={this.state.hostEnv}
        onHostEnvChange={this.handleHostEnvChange}
        hostRole={this.state.hostRole}
        onHostRoleChange={this.handleHostRoleChange}
        allGames={this.props.allGames}
        onGameIdChange={this.handleGameIdChange}
        gameId={this.state.gameId}
      />
    )
  }
}

const mapStateToProps = state => ({
  gameId: state.game.gameId,
  allGames: state.game.games,
  deviceId: state.device.deviceId,
  registered: state.device.registered,
  registering: state.device.registering,
  registerError: state.device.error,
  teamId: state.team.id,
  isMaster: state.device.isMaster,
  sideBarFontSize: state.ui.sideBarFontSize,
  hostname: state.device.hostname,
  hostType: state.device.hostType,
  hostEnv: state.device.hostEnv,
  hostRole: state.device.hostRole
})

export default connect(
  mapStateToProps,
  {
    registerDevice,
    onHostChange
  }
)(SettingsContainer)
